import groq from 'groq'

export const companiesQuery = groq`
  *[_type == "company"] | order(order asc) {
    _id,
    title,
    description,
    websiteUrl,
    logo {
      asset->{
        _id,
        url,
        metadata {
          dimensions {
            width,
            height
          }
        }
      },
      alt
    },
    keyServices,
    cardType,
    isMainCompany,
    order
  }
`

export const mainCompaniesQuery = groq`
  *[_type == "company" && isMainCompany == true] | order(order asc) {
    _id,
    title,
    description,
    websiteUrl,
    logo {
      asset->{
        _id,
        url,
        metadata {
          dimensions {
            width,
            height
          }
        }
      },
      alt
    },
    keyServices,
    cardType,
    isMainCompany,
    order
  }
`

export const ellipseCompaniesQuery = groq`
  *[_type == "company" && cardType == "ellipse"] | order(order asc) {
    _id,
    title,
    description,
    websiteUrl,
    logo {
      asset->{
        _id,
        url,
        metadata {
          dimensions {
            width,
            height
          }
        }
      },
      alt
    },
    keyServices,
    cardType,
    isMainCompany,
    order
  }
`

// Localized queries that accept locale parameter
export const localizedCompaniesQuery = (locale: string) => groq`
  *[_type == "company"] | order(order asc) {
    _id,
    "title": title.${locale},
    "description": description.${locale},
    websiteUrl,
    logo {
      asset->{
        _id,
        url,
        metadata {
          dimensions {
            width,
            height
          }
        }
      },
      alt
    },
    "keyServices": keyServices.${locale},
    cardType,
    isMainCompany,
    order
  }
`

export const localizedMainCompaniesQuery = (locale: string) => groq`
  *[_type == "company" && isMainCompany == true] | order(order asc) {
    _id,
    "title": title.${locale},
    "description": description.${locale},
    websiteUrl,
    logo {
      asset->{
        _id,
        url,
        metadata {
          dimensions {
            width,
            height
          }
        }
      },
      alt
    },
    "keyServices": keyServices.${locale},
    cardType,
    isMainCompany,
    order
  }
`

export const localizedEllipseCompaniesQuery = (locale: string) => groq`
  *[_type == "company" && cardType == "ellipse"] | order(order asc) {
    _id,
    "title": title.${locale},
    "description": description.${locale},
    websiteUrl,
    logo {
      asset->{
        _id,
        url,
        metadata {
          dimensions {
            width,
            height
          }
        }
      },
      alt
    },
    "keyServices": keyServices.${locale},
    cardType,
    isMainCompany,
    order
  }
`
